import { render, staticRenderFns } from "./WidgetLibrary.vue?vue&type=template&id=03519ea6&scoped=true"
import script from "./WidgetLibrary.vue?vue&type=script&lang=ts"
export * from "./WidgetLibrary.vue?vue&type=script&lang=ts"
import style0 from "./WidgetLibrary.vue?vue&type=style&index=0&id=03519ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03519ea6",
  null
  
)

export default component.exports